var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DsfrTextField',_vm._g(_vm._b({attrs:{"label":"Prénom et nom","autocomplete":"name","spellcheck":"false","rules":_vm.rules || []}},'DsfrTextField',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }